<template>
  <section :class="['accordion__item', { 'accordion__item--active': active }]">
    <div class="accordion__item__title" @click="active = !active">
      <h3 v-html="title"></h3>
    </div>
    <div class="accordion__item__body">
      <p v-html="text"></p>
    </div>
  </section>
</template>

<script>
export default {
  props: ['title', 'text'],
  data() {
    return {
      active: false,
    };
  },
};
</script>

<style lang="scss">
.accordion {
  &__item {
    background: RGBA(255, 255, 255, 0.7);
    border-radius: 10px;
    padding: 0px 13px;
    margin-bottom: 20px;
    text-align: center;
    @include media('>=tablet') {
      padding: 0px 20px;
      text-align: left;
    }
    &--active {
      .accordion__item__body {
        padding: 20px 0;
        max-height: 1000px;
      }
    }
    &__body {
      max-height: 0px;
      overflow: hidden;
      transition: 0.4s ease-in-out;
      p {
        color: $color-black;
        font-size: 16px;
        line-height: 19px;
      }
    }
    &__title {
      padding: 17px 0 19px;
      cursor: pointer;
      &:hover {
        h3 {
          font-weight: 900;
        }
      }

      h3 {
        border-radius: 10px;
        color: $color-black;
        width: 100%;
        text-decoration: none;
        font-weight: 400;
        font-size: 13px;
        justify-content: center;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        text-align: center;
        @include media('>=tablet') {
          font-size: 14px;
          display: flex;
          margin: 0 auto;
        }
        strong {
          font-weight: 900;
          margin: 0 4px;
        }
      }
    }
  }
}
</style>
